import { NextSeo } from 'next-seo';
import Head from 'next/head';

import { About } from '/screens/';

export default function AboutPage() {
  return (
    <>
      <Head>
        <meta
          name="keywords"
          content="about loadsmart, loadsmart, logistics companies, logistics companies chicago, freight tech,"
        />
      </Head>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG}
        noindex={process.env.NOINDEX_FLAG}
        title="About Us"
        description="Learn more about how we are changing freight technology to help you move more with less offering freight brokerage, shipping, carrier and warehouse services."
        canonical="https://loadsmart.com/about/"
        openGraph={{
          url: 'https://loadsmart.com/about/',
        }}
      />
      <About />
    </>
  );
}
